import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFormDispatch, updateField } from './FormStateMachine';
import { UTM_STORAGE_KEY } from './utils/gtmTracking';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

const URLStateInitializer = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useFormDispatch();

  useEffect(() => {
    const utmParams = {};
    UTM_KEYS.forEach(key => {
      const value = searchParams.get(key);
      if (value) utmParams[key] = value;
    });

    if (Object.keys(utmParams).length > 0 && typeof window !== 'undefined') {
      try {
        window.sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams));
      } catch (error) {
        // Ignore storage errors to avoid breaking URL state initialization
      }
    }

    const validParams = {
      plan: (value) => updateField(dispatch, 'plan', value),
      sponsorId: (value) => updateField(dispatch, 'sponsorId', value),
      subscriptionLength: (value) => updateField(dispatch, 'subscriptionLength', value),
      promoCode: (value) => updateField(dispatch, 'promoCode', value),
      referral: (value) => updateField(dispatch, 'referral', value),
      companyId: (value) => updateField(dispatch, 'companyId', value)
    };

    for (let [key, value] of searchParams.entries()) {
      if (validParams[key]) {
        validParams[key](value);
      }
    }
  }, [searchParams, dispatch]);

  return null; // This component does not render anything
};

export default URLStateInitializer; 
